module.exports = __webpack_public_path__ + "client-static/img/logo_livin.dda0592.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_livin.png
// module id = S458
// module chunks = 2